// extracted by mini-css-extract-plugin
module.exports = {"child":"UserBoxAuthenticated-child-2QtmO","userBoxText":"UserBoxAuthenticated-userBoxText-3JSQ3","userBoxButton":"UserBoxAuthenticated-userBoxButton-1EdY7"};